@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.root {
  display: flex;
  align-items: center;
  color: var(--neutral-90);
  padding: 0 8px;
  outline: none;
  border-radius: 4px;
  cursor: pointer;
  scroll-margin: 4px;
  @include sm-sohne-medium;
  min-height: 36px;

  &:before {
    content: none !important;
  }

  &:hover {
    background: var(--dark-4);
  }

  [data-autopilot-system-redesign='on'] & {
    color: var(--dark-90);
    @include sm-sohne;

    &:hover {
      background: var(--dark-3);
    }
  }
}

.content {
  display: flex;
  flex: 1;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  column-gap: 8px;

  svg {
    fill: var(--neutral-50);
    flex-shrink: 0;
  }
}

.checkIcon {
  display: flex;
  align-items: center;
  justify-content: center;

  [data-autopilot-system-redesign='on'] & {
    width: 16px;
    height: 16px;
    background: var(--dark-80);
    border-radius: 50%;

    svg {
      color: var(--light-100);
      width: 10px;
      height: 10px;
    }
  }
}

.focused {
  background: var(--dark-4);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.selected {
  position: relative;
  background: var(--selected-fill);
  color: var(--light-100);

  &:hover,
  &.focused:hover {
    background: var(--selected-fill);
  }

  [data-autopilot-system-redesign='on'] & {
    border-radius: 4px;
    border: none;
    background: var(--dark-4);
    color: var(--dark-90);
    font-weight: 500;

    &:hover,
    &.focused:hover {
      border: none;
      background: var(--dark-4);
      color: var(--dark-90);
    }
  }
}

.checkIcon {
  fill: var(--neutral-90);
  margin-left: 8px;
}
